import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const changeLanguage = (language) => {
  i18n.changeLanguage(language);
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "ku",
    fallbackLng: "ku",
    detection: {
      order: ["cookie"],
      lookupCookie: "language",
      caches: ["cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// eslint-disable-next-line import/no-anonymous-default-export
export default { changeLanguage, i18n };
